<template>
  <div class="index content-continer">
    <div class="statistics-top">
      <el-row :gutter="240">
        <el-col :span="8">
          <div class="statistics-list">
            <p>CRC总数</p>
            <p>{{line.crcNumPlus}}</p>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="statistics-list">
            <p>医院总数</p>
            <p>{{line.hospitalNum}}</p>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="statistics-list">
            <p>项目总数</p>
            <p>{{line.projectNum}}</p>
          </div>
        </el-col>
        <!-- <el-col>
          <div class="statistics-list">
            <p>CRA总数</p>
            <p>{{line.craNum}}</p>
          </div>
        </el-col> -->
      </el-row>
    </div>
    <!-- 图表们 -->
    <!-- 柱形图 -->
    <div class="continer-title base-content">
      <div class="blue">项目数统计</div>
    </div>
    <div id="myChart" style="height:400px" class="base-content"></div>
    <!-- 饼图 -->
    <!-- <div class="continer-title base-content" style="margin-top:20px;">
      <div class="blue">科室CRC/CRA人数统计</div>
    </div>
    <div id="myChart2" style="height:400px" class="base-content"></div> -->
    <!-- 表格 -->
    <!-- 饼图 -->
    <div class="continer-title base-content" style="margin-top:20px;">
      <div class="blue">CRC人数统计</div>
    </div>
    <div class="base-content" style="margin-bottom: 200px;">
      <el-table :data="tableData" style="width: 100%" :header-cell-style="{background:'#D0EAFF',color:'#333333'}">
        <el-table-column prop="specialityName" label="专业" width="180"></el-table-column>
        <el-table-column prop="hospitalName" label="医院名称"></el-table-column>
        <el-table-column prop="projectName" label="项目名称"></el-table-column>  
        <el-table-column prop="startDate" label="项目时间"></el-table-column>
        <el-table-column prop="crcNum" label="CRC人数/人" width="140"></el-table-column>
        
      </el-table>
    </div>
  </div>
</template>

<script>
  import echarts from "echarts";
  import Cookies from 'js-cookie'
  import { Cstatistics } from '@/request/api'
  export default {
    name: "index",
    data() {
      return {
        msg: "sdfdsf",
        userid: "",
        linelist: [],
        line: '',
        tableData: []
      };
    },
    created() {
      this.userid = Cookies.get("userid");
    },
    mounted() {

      Cstatistics(this.userid).then((res) => {
        this.linelist = res.data.data.list;
        console.log(this.linelist);
        this.drawLine();
        this.line = res.data.data;
        this.tableData = res.data.data.list2;
      }).catch((err) => {
        console.log(err)
      })

      // this.drawround();
    },
    methods: {
      // 柱形图
      drawLine() {
        // 基于准备好的dom，初始化echarts实例
        let myChart = echarts.init(document.getElementById("myChart"));
        // 绘制图表
        myChart.setOption({
          legend: {
            x: "right",
            itemGap: 50,
          },
          tooltip: {},
          dataset: {
            dimensions: ['hospitalName', 'crcNum'],
            source: this.linelist
          },
          xAxis: {
            type: "category",
            axisLabel: {
              interval: 0,
              rotate: 20,//倾斜度 -90 至 90 默认为0
              margin: 5,
              textStyle: {
                fontSize: "10px",
                color: "#666",
                fontWeight: "normal"
              }
            }
          },
          yAxis: {},
          // Declare several bar series, each will be mapped
          // to a column of dataset.source by default.
          series: [
            {
              type: "bar",
              barGap: "0%",
              barWidth: 30,
              name: "CRC人数",
              // barCategoryGap:'50%',
              itemStyle: {
                normal: {
                  color: function (params) {
                    var colorList = ["#FA7373"];
                    return colorList[params.dataIndex];
                  },
                  label: {
                    show: true, //开启显示
                    position: "top", //在上方显示
                    textStyle: {
                      //数值样式
                      color: "#EF4343",
                      fontSize: 16
                    }
                  }
                }
              }
            }
          ]
        });
      }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .statistics-top {
    margin-top: 30px;
    margin-bottom: 30px;
  }

  .statistics-top .statistics-list {
    width: 100%;
    height: 109px;
    padding-top: 20px;
    padding-left: 20px;
  }


  .statistics-top .el-col:first-child>div {
    background: url(../assets/company1.png) no-repeat;
  }

   .statistics-top .el-col:nth-child(2)>div{
    background: url(../assets/company2.png) no-repeat;
  }

  .statistics-top .el-col:nth-child(3)>div{
    background: url(../assets/company3.png) no-repeat;
  }

  .statistics-top .el-col:nth-child(4)>div{
    background: url(../assets/company4.png) no-repeat;
  } 

  .statistics-list p {
    color: #fff;
    /* padding-left:20px; */
  }

  .statistics-list p:first-child {
    font-size: 18px;
    margin-bottom: 16px;
  }

  .statistics-list p:last-child {
    font-size: 24px;
  }

  .el-table th.is-leaf {
    background: #D0EAFF !important;
  }
</style>


// WEBPACK FOOTER //
// src/company/statistics.vue